import { SvgIcon, type SvgIconProps } from "@mui/material";

export const BookIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} fill="none" viewBox="0 0 64 64" stroke="currentColor">
    <path
      d="M23.5 38.75C23.09 38.75 22.75 38.41 22.75 38V27C22.75 22.59 24.09 21.25 28.5 21.25H35.5C39.91 21.25 41.25 22.59 41.25 27V37C41.25 37.16 41.25 37.31 41.24 37.47C41.21 37.88 40.84 38.2 40.44 38.17C40.03 38.14 39.71 37.78 39.74 37.37C39.75 37.25 39.75 37.12 39.75 37V27C39.75 23.43 39.08 22.75 35.5 22.75H28.5C24.92 22.75 24.25 23.43 24.25 27V38C24.25 38.41 23.91 38.75 23.5 38.75Z"
      fill="black"
    />
    <path
      d="M36 27.75H28C27.59 27.75 27.25 27.41 27.25 27C27.25 26.59 27.59 26.25 28 26.25H36C36.41 26.25 36.75 26.59 36.75 27C36.75 27.41 36.41 27.75 36 27.75Z"
      fill="black"
    />
    <path
      d="M37 42.75H27C24.66 42.75 22.75 40.84 22.75 38.5V37.85C22.75 35.86 24.37 34.25 26.35 34.25H40.5C40.91 34.25 41.25 34.59 41.25 35V38.5C41.25 40.84 39.34 42.75 37 42.75ZM26.35 35.75C25.19 35.75 24.25 36.69 24.25 37.85V38.5C24.25 40.02 25.48 41.25 27 41.25H37C38.52 41.25 39.75 40.02 39.75 38.5V35.75H26.35Z"
      fill="black"
    />

    <path
      d="M33 31.25H28C27.59 31.25 27.25 30.91 27.25 30.5C27.25 30.09 27.59 29.75 28 29.75H33C33.41 29.75 33.75 30.09 33.75 30.5C33.75 30.91 33.41 31.25 33 31.25Z"
      fill="black"
    />
  </SvgIcon>
);


